// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   Grid,
//   Typography,
//   Box,
//   TextareaAutosize,
// } from "@mui/material";
// import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
// import Cropper from "react-easy-crop";
// import Slider from "@mui/material/Slider";
// import getCroppedImg from "./getCroppedImg"; // Helper function for cropping (see below)

// const RemedyForm = () => {
//   const [formData, setFormData] = useState({
//     user_id: "",
//     subCategory_id: "",
//     subCategory_name: "",
//     category_name: "",
//     title_name: "",
//     views: "",
//     likes: "",
//     totalrating: "",
//     totalreviewrecipe_message: "",
//     tags: "",
//     short_description: "",
//     contents: "",
//     video_url: "",
//     faqs: "",
//     conclusions: "",
//     author_name: "",
//     contents_two: "",
//     recommended_consumption: "",
//     storage: "",
//     duration: "",
//     subTitle: "",
//     type: "",
//     is_featured: "",
//     created_at: "",
//     updated_at: "",
//   });

//   const [image, setImage] = useState(null);
//   const [croppedArea, setCroppedArea] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [zoom, setZoom] = useState(1);
//   const [croppedImage, setCroppedImage] = useState(null);
//   const [aspectRatio, setAspectRatio] = useState(1); // Aspect ratio control

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => {
//         setImage(reader.result);
//       };
//     }
//   };

//   const onCropComplete = (croppedArea, croppedAreaPixels) => {
//     setCroppedArea(croppedAreaPixels);
//   };

//   const handleCrop = async () => {
//     try {
//       const croppedImg = await getCroppedImg(image, croppedArea);
//       setCroppedImage(croppedImg);
//       alert("Image cropped successfully!");
//     } catch (error) {
//       console.error("Crop error:", error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formDataToSend = new FormData();
//     console.log(formDataToSend);
//     for (const key in formData) {
//       formDataToSend.append(key, formData[key]);
//     }
//     if (croppedImage) formDataToSend.append("remedyImage", croppedImage);

//     try {
//       const response = await fetch(
//         "http://localhost:3030/api/remedyfoods/remedyfoodsadder",
//         {
//           method: "POST",
//           body: formDataToSend,
//         }
//       );

//       const result = await response.json();
//       if (response.ok) {
//         alert(result.message);
//       } else {
//         alert(result.message);
//       }
//     } catch (error) {
//       console.error("Error adding recipe:", error);
//       alert("Error adding recipe, try again later.");
//     }
//   };

//   return (
//     <Box sx={{ padding: 3 }}>
//       <Typography variant="h4" gutterBottom>
//         Add Recipe
//       </Typography>
//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3}>
//           {/* Form Fields */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="User ID"
//               variant="outlined"
//               fullWidth
//               name="user_id"
//               value={formData.user_id}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* SubCategory ID */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="SubCategory ID"
//               variant="outlined"
//               fullWidth
//               name="subCategory_id"
//               value={formData.subCategory_id}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* SubCategory Name */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="SubCategory Name"
//               variant="outlined"
//               fullWidth
//               name="subCategory_name"
//               value={formData.subCategory_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Meal Type ID */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Category Name"
//               variant="outlined"
//               fullWidth
//               name="category_name"
//               value={formData.category_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Meal Type Name */}
//           {/* <Grid item xs={12} md={6}>
//             <TextField
//               label="Category Name"
//               variant="outlined"
//               fullWidth
//               name="category_name"
//               value={formData.category_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid> */}

//           {/* Recipe Title */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Title"
//               variant="outlined"
//               fullWidth
//               name="title_name"
//               value={formData.title_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Views"
//               variant="outlined"
//               fullWidth
//               name="views"
//               value={formData.views}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Likes"
//               variant="outlined"
//               fullWidth
//               name="likes"
//               value={formData.likes}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Rating */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Total Rating"
//               variant="outlined"
//               fullWidth
//               name="totalrating"
//               value={formData.totalrating}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Review Message */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Review Message"
//               variant="outlined"
//               fullWidth
//               name="totalreviewrecipe_message"
//               value={formData.totalreviewrecipe_message}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* tags */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Tags"
//               variant="outlined"
//               fullWidth
//               name="tags"
//               value={formData.tags}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Short Description */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Short Description"
//               variant="outlined"
//               fullWidth
//               name="short_description"
//               value={formData.short_description}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Equipment Recipe ID */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="contents"
//               variant="outlined"
//               fullWidth
//               name="contents"
//               value={formData.contents}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Equipment Recipe Title */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="video url"
//               variant="outlined"
//               fullWidth
//               name="video_url"
//               value={formData.video_url}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* FAQS */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="FAQS"
//               variant="outlined"
//               fullWidth
//               name="faqs"
//               value={formData.faqs}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Recipe Summary */}
//           <Grid item xs={12} md={6}>
//             <TextareaAutosize
//               minRows={3}
//               placeholder="Conclusions"
//               style={{ width: "100%" }}
//               name="conclusions"
//               value={formData.conclusions}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Author Name */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Author Name"
//               variant="outlined"
//               fullWidth
//               name="author_name"
//               value={formData.author_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* contents two */}
//           {/* <Grid item xs={12} md={6}>
//             <TextField
//               label="contents two"
//               variant="outlined"
//               fullWidth
//               name="contentsTwo"
//               value={formData.contentsTwo}
//               onChange={handleChange}
//             />
//           </Grid> */}

//           {/* recommended */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Contents Two"
//               variant="outlined"
//               fullWidth
//               name="contents_two"
//               value={formData.contents_two}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* recommended */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Recommended Consumption"
//               variant="outlined"
//               fullWidth
//               name="recommended_consumption"
//               value={formData.recommended_consumption}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* storage*/}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Storage"
//               variant="outlined"
//               fullWidth
//               name="storage"
//               value={formData.storage}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* duration*/}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Duration"
//               variant="outlined"
//               fullWidth
//               name="duration"
//               value={formData.duration}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* sub title*/}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Sub Title"
//               variant="outlined"
//               fullWidth
//               name="subTitle"
//               value={formData.subTitle}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Type*/}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Type"
//               variant="outlined"
//               fullWidth
//               name="type"
//               value={formData.type}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Created At */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Created At"
//               variant="outlined"
//               fullWidth
//               name="created_at"
//               value={formData.created_at}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Updated At */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Updated At"
//               variant="outlined"
//               fullWidth
//               name="updated_at"
//               value={formData.updated_at}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Featured */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="Is Featured?"
//               name="is_featured"
//               value={formData.is_featured}
//               onChange={handleChange}
//             />
//           </Grid>

//           <Box sx={{ mb: 2 }}>
//             <TextField
//               type="file"
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//               onChange={handleImageChange}
//             />
//           </Box>

//           {/* Aspect Ratio Slider */}
//           <Box sx={{ mb: 2 }}>
//             <Typography>Aspect Ratio: {aspectRatio}</Typography>
//             <Slider
//               value={aspectRatio}
//               min={0.1}
//               max={3}
//               step={0.1}
//               onChange={(e, newValue) => setAspectRatio(newValue)}
//             />
//           </Box>

//           {/* Other fields... */}

//           {/* Image Upload */}
//           <Grid item xs={12}>
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<CloudUploadIcon />}
//             >
//               Upload Recipe Image
//               <input type="file" hidden onChange={handleImageChange} />
//             </Button>
//           </Grid>

//           {/* Image Cropper */}
//           {image && (
//             <Box
//               sx={{
//                 marginTop: 3,
//                 position: "relative",
//                 height: 300,
//                 width: 300,
//               }}
//             >
//               <Cropper
//                 image={image}
//                 crop={crop}
//                 zoom={zoom}
//                 aspect={aspectRatio} // Set aspect ratio
//                 onCropChange={setCrop}
//                 onZoomChange={setZoom}
//                 onCropComplete={onCropComplete}
//               />
//               <Slider
//                 value={zoom}
//                 min={1}
//                 max={3}
//                 step={0.1}
//                 aria-labelledby="Zoom"
//                 onChange={(e, zoom) => setZoom(zoom)}
//                 sx={{ marginTop: 2 }}
//               />
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={handleCrop}
//                 sx={{ marginTop: 2 }}
//               >
//                 Crop Image
//               </Button>
//             </Box>
//           )}

//           {/* Submit Button */}
//           <Grid item xs={12}>
//             <Button variant="contained" color="primary" type="submit">
//               Add Recipe
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default RemedyForm;

import React from "react";

function RemedyForm() {
  return <div>RemedyForm</div>;
}

export default RemedyForm;
